<form #uploadForm>
  <input type="file" #fileInput class="d-none" (change)="onSignatureFileSelected(fileInput.files)" />
</form>
<div class="text-bold mb-3" i18n>Use a photo of your signature</div>

<div [class.d-none]="isFileUploaded">
  <button class="btn btn-secondary-info" (click)="fileInput.click()">
    <i class="cs-icon cs-icon-image-plus"></i> <ng-container i18n>Add Photo</ng-container>
  </button>

  <div class="help-info">
    <div><ng-container i18n>Acceptable file formats</ng-container>: <span> png, jpg, jpeg, bmp, gif</span></div>
    <div><ng-container i18n>Max file size</ng-container>: <span>40MB</span></div>
  </div>
</div>

<div class="drawer-wrapper" [class.d-none]="!isFileUploaded">
  <canvas #signatureCanvas [style.width.px]="editorSize.width" [style.height.px]="editorSize.height"></canvas>
</div>
